export default function resolveUrl(url) {
  return new URL(url, location.toString()).toString()
}
